

import React, { useState } from "react";
import "./OurValues.css";

const OurValues = () => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  return (
    <div>
      <div className="hero_img values_mobile_img">
      <img src="/assets/values_banner.jpg" alt="" />

        <div className="hero_title">Our Guiding Principles</div>
      </div>
      <div className="container2">
        <div className="value_div1">
          <img src="/assets/ourvalues/Values-1.png" alt="" width={200} />
          <h2>Our Vision</h2>
          <span>“Enabling Connections for Life”</span>
        </div>
        <div className="value_div1">
          <img src="/assets/ourvalues/Values-13.png" alt="" />
          <h2>Our Mission</h2>
          <span>
            “Be a Leading Digital Connectivity Infrastructure partner” <br />{" "}
            admired and preferred by all our stakeholders.
          </span>
        </div>
        <div className="value_div1">
          <img src="/assets/ourvalues/Values-15.png" alt="" />
          <h2>Our Values</h2>
          <img
            className="valuesvg"
            src="/assets/ourvalues/valuesvg.svg"
            alt=""
          />
          <p>
            Belief in our core values acts as a compass for our actions as a
            company and as a means of constructing successful teams. For us,
            being committed to our values and principles allows us to be able to
            govern our business as well as how we expect our employees to behave
            in the workplace. In Crest Digitel, we believe that values are
            overarching and that they do not merely relate to one situation, but
            rather to how we apply them to everything we do and how we interact
            with one another and with our business partners.
          </p>
        </div>
        <div className="value_div2">
          <div className="value_div21">
            <div className={`flip-container ${isFlipped ? "flip" : ""}`}>
              <div className="flipper">
                <div className="front">
                  <img
                    src="/assets/ourvalues/valueimg5.svg"
                    alt=""
                    className="hide-on-hover"
                  />
                </div>
                <div className="back">
                  <img
                    src="/assets/ourvalues/valueimg51.svg"
                    alt=""
                    className="show-on-hover"
                  />
                </div>
              </div>
            </div>

            <div className={`flip-container ${isFlipped ? "flip" : ""}`}>
              <div className="flipper">
                <div className="front">
                  <img
                    src="/assets/ourvalues/valueimg6.svg"
                    alt=""
                    className="hide-on-hover"
                  />
                </div>
                <div className="back">
                  <img
                    src="/assets/ourvalues/valueimg61.svg"
                    alt=""
                    className="show-on-hover"
                  />
                </div>
              </div>
            </div>

            <div className={`flip-container ${isFlipped ? "flip" : ""}`}>
              <div className="flipper">
                <div className="front">
                  <img
                    src="/assets/ourvalues/valueimg7.svg"
                    alt=""
                    className="hide-on-hover"
                  />
                </div>
                <div className="back">
                  <img
                    src="/assets/ourvalues/valueimg71.svg"
                    alt=""
                    className="show-on-hover show-on-hover2"
                  />
                </div>
              </div>
            </div>

            {/* <img src="/assets/ourvalues/valueimg7.svg" alt=""  /> */}
          </div>

          <div className="value_div21">
            <div className={`flip-container ${isFlipped ? "flip" : ""}`}>
              <div className="flipper">
                <div className="front">
                  <img
                    src="/assets/ourvalues/valueimg8.svg"
                    alt=""
                    className="hide-on-hover"
                  />
                </div>
                <div className="back">
                  <img
                    src="/assets/ourvalues/valueimg81.svg"
                    alt=""
                    className="show-on-hover"
                  />
                </div>
              </div>
            </div>

            <div className={`flip-container ${isFlipped ? "flip" : ""}`}>
              <div className="flipper">
                <div className="front">
                  <img
                    src="/assets/ourvalues/valueimg9.svg"
                    alt=""
                    className="hide-on-hover"
                  />
                </div>
                <div className="back">
                  <img
                    src="/assets/ourvalues/valueimg91.svg"
                    alt=""
                    className="show-on-hover show-on-hover3"
                  />
                </div>
              </div>
            </div>

            <div className={`flip-container ${isFlipped ? "flip" : ""}`}>
              <div className="flipper">
                <div className="front">
                  <img
                    src="/assets/ourvalues/valueimg10.svg"
                    alt=""
                    className="hide-on-hover"
                  />
                </div>
                <div className="back">
                  <img
                    src="/assets/ourvalues/valueimg101.svg"
                    alt=""
                    className="show-on-hover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurValues;
